import React from 'react';
import { useMessageGetter } from 'react-message-context';
import PageContainer from '../PageContainer';
import PaddedContent from '../../components/housing/PaddedContent';
import { RouteComponentProps } from 'react-router';
import WordPressContent, { WpPostType } from '../../components/wordpress/WordPressContent';
import { getContentBlockSlug } from '../pageUtils';
import { useAppState } from '../../context/appContext';
import Liftup from '../../components/Liftup';
import BasicBuildingInfo from '../../components/BasicBuildingInfo';
import InfoBlock from '../../components/housing/infoblock/InfoBlock';
import SafetyAndEvacuation from '../../components/housing/infoblock/SafetyAndEvacuation';
import AdditionalBuildingInfo from '../../components/housing/infoblock/AdditionalBuildingInfo';
import { getMenuItemPathBySlug } from '../../utils/wordpress';
import { BlockSlugs, Slugs } from '../../constants/knownSlugs';
import { LinkButtonWithChevron } from '../../components/common';
import { theme } from '../../theme';
import { LinkContainer } from '../layoutComponents';

/* const CardContainer = styled(LinkContainer)`
  @media ${DeviceSize.desktopM} {
    display: flex;
    flex-direction: column;
  }

  h4 {
    width: unset;
  }
`; */

/** Styles are updated to match the new design.
 * TODO: Fetch data from Kenno or M-Files. */
const BuildingInfoPage = ({ history }: RouteComponentProps) => {
  const t = useMessageGetter('housing');
  const { language, menu } = useAppState();
  //const [parkingDocument, setParkingDocument] = useState<Document | undefined>(undefined);

  /*   useEffect(() => {
    loadHousingCoop(dispatch);
    getDocumentsList(dispatch);
    loadHousing(dispatch);
    loadApartment(dispatch);
  }, [dispatch]); */

  // TODO: Switch these to use new data when it can be fetched from Kenno or M-Files.
  // Documents and modules used in code below refer the to old Tampuuri spesific tenant state.

  /*   useEffect(() => {
    documents.documents &&
      setParkingDocument(documents.documents.find((document) => document.categoryType === 'Autopaikkakartta'));
  }, [documents]);

  const hasOne4All = modules.modules && modules.modules.length > 0;
  const hasSauna =
    housingInfo.features && housingInfo.features.some((feature) => feature.isExist && feature.name === 'buildingSauna');
  const hasLaundry = housingInfo.laundry;

  const saunaSlug = getSaunaSlug(hasSauna, hasOne4All);
  const laundrySlug = getLaundrySlug(hasLaundry, hasOne4All);
  const internetSlug = getInternetSlug(housingInfo?.isp, housingInfo?.broadbandType); */

  return (
    <PageContainer history={history}>
      <PaddedContent paddingTop="40px">
        <Liftup>
          <BasicBuildingInfo />
        </Liftup>
        <LinkContainer>
          <LinkButtonWithChevron
            to={getMenuItemPathBySlug(menu.items, Slugs.FAULT_REPORT)}
            icon="errorOutline"
            color={theme().colors.darkSnow}
          >
            {t('reportFault')}
          </LinkButtonWithChevron>
          <LinkButtonWithChevron
            to={getMenuItemPathBySlug(menu.items, Slugs.EVENTS)}
            icon="starOutlined"
            color={theme().colors.darkSnow}
          >
            {t('events.title')}
          </LinkButtonWithChevron>
          <LinkButtonWithChevron
            to={getMenuItemPathBySlug(menu.items, Slugs.NOTICES)}
            icon="leading"
            color={theme().colors.darkSnow}
          >
            {t('notices.title')}
          </LinkButtonWithChevron>
          <LinkButtonWithChevron
            to={getMenuItemPathBySlug(menu.items, Slugs.SAFETY)}
            icon="trailing"
            color={theme().colors.darkSnow}
          >
            {t('emergencyplan.documentname')}
          </LinkButtonWithChevron>
        </LinkContainer>
        {/*         <CardContainer>
          <Card background={theme().colors.strawberry} title={t('housefeat.title')}>
            <BuildingFeatures />
          </Card>
        </CardContainer> */}
      </PaddedContent>
      <InfoBlock title={t('moreInfo')} hasLink={false}>
        <AdditionalBuildingInfo />
      </InfoBlock>
      {/*       <InfoBlock
        title={t('sauna.title')}
        hasLink={hasSauna && hasOne4All}
        linkLabel={t('booking.moreInfo')}
        linkTo={getMenuItemPathBySlug(menu.items, Slugs.BOOKING_CALENDAR)}
      >
        {saunaSlug && (
          <WordPressContent slug={getContentBlockSlug(saunaSlug, language)} postType={WpPostType.CONTENT_BLOCKS} />
        )}
      </InfoBlock>
      <InfoBlock
        title={t('housefeat.laundryroom')}
        hasLink={hasLaundry && hasOne4All}
        linkLabel={t('booking.moreInfo')}
        linkTo={getMenuItemPathBySlug(menu.items, Slugs.BOOKING_CALENDAR)}
      >
        {laundrySlug && (
          <WordPressContent slug={getContentBlockSlug(laundrySlug, language)} postType={WpPostType.CONTENT_BLOCKS} />
        )}
      </InfoBlock>
      <InfoBlock title={t('internet.title')} hasLink={false}>
        {internetSlug && (
          <WordPressContent slug={getContentBlockSlug(internetSlug, language)} postType={WpPostType.CONTENT_BLOCKS} />
        )}
      </InfoBlock> */}
      <InfoBlock title={t('safety.title')} hasLink={false}>
        <SafetyAndEvacuation />
      </InfoBlock>
      <InfoBlock title={t('storage.title')} hasLink={false}>
        <WordPressContent
          slug={getContentBlockSlug(BlockSlugs.STORAGE, language)}
          postType={WpPostType.CONTENT_BLOCKS}
        />
      </InfoBlock>
      <InfoBlock title={t('parking.title')} hasLink={false}>
        <>
          <WordPressContent
            slug={getContentBlockSlug(BlockSlugs.PARKING, language)}
            postType={WpPostType.CONTENT_BLOCKS}
          />
          {/* TODO: Uncomment when parking document is available from M-Files */}
          {/* {parkingDocument && <DocumentItem type="" item={parkingDocument} icon={whiteDownloadIcon} />} */}
        </>
      </InfoBlock>
    </PageContainer>
  );
};

export default BuildingInfoPage;
